import { lazyRouteComponent } from "@tanstack/react-router";
import type { At } from "../../router";

export const ContractsRoutes = (at: At) => [
  at("/contracts", lazyRouteComponent(() => import("./Contracts"), "ContractsList")),
  at("/contracts/new", lazyRouteComponent(() => import("./Contracts"), "ContractEditor")),
  at("/contracts/billing", lazyRouteComponent(() => import("./Contracts"), "ContractsToBill")),
  at("/contracts/reports", lazyRouteComponent(() => import("./Contracts"), "ContractsReports")),
  at("/contracts/$id", lazyRouteComponent(() => import("./Contracts"), "ContractPage")),
  at("/contracts/$id/edit", lazyRouteComponent(() => import("./Contracts"), "ContractEditor")),
];
